import { gmail, blackboltConfig } from "../../constants";

const attachSigninToCustomButton = (element, auth2, login) => {
  if (auth2) {
    // eslint-disable-next-line
    element.disabled = false;
    auth2.attachClickHandler(
      element,
      {},
      googleUser => {
        const accessToken = googleUser.getAuthResponse().access_token;
        login(accessToken, blackboltConfig.google);
      },
      error => error,
    );
  }
};

const setGmail = login => {
  const { gapi } = window;
  const { appId, cookiepolicy, scope } = gmail;
  gapi.load("auth2", () => {
    // Retrieve the singleton for the GoogleAuth library and set up the client.
    // eslint-disable-next-line
    const auth2 = gapi.auth2.init({
      client_id: appId,
      cookiepolicy,
      scope,
      // Request scopes in addition to 'profile' and 'email'
      // scope: 'additional_scope'
    });
    window.auth2 = auth2;
    attachSigninToCustomButton(
      document.getElementById("google-login"),
      auth2,
      login,
    );
  });
};

const gmailInit = login => {
  if (window.gapi) {
    setGmail(login);
  } else {
    const script = document.createElement("script");
    script.async = true;
    script.onload = () => {
      setTimeout(
        () => {
          setGmail(login);
        },
        300,
        false,
      );
    };
    script.setAttribute("type", "text/javascript");
    script.setAttribute("src", "https://apis.google.com/js/platform.js");
    document.getElementsByTagName("head")[0].appendChild(script);
  }
};

export { gmailInit, attachSigninToCustomButton };



// WEBPACK FOOTER //
// ./src/component/Login/utils.js